import MainTrackVoluntier from "../../components/track-voluntier/main-track-voluntier";

function TrackVoluntier() {
  return (
    <div className="w-[90%] lg:w-[95%] mx-auto mt-8">
        <MainTrackVoluntier/>
    </div>
  );
}

export default TrackVoluntier;


